/**
 * BlockedOverlayVariant
 *
 * Which (if any) full-screen blocked overlay is currently active over the
 * chat message list. Promoted from a presentation-layer string-literal union
 * per `conventions.md` § "Enums live in the domain layer".
 *
 * Flutter source of truth (`chat_screen.dart:1010-1113`):
 *  - `currentUserBlocked` — the current user has been blocked by an admin
 *    (mirrors `_currentUserBlocked`, `chat_screen.dart:1011`).
 *  - `currentUserBlockedByPeer` — the peer has blocked the current user
 *    (mirrors `_currentUserBlockedByPeer`, `chat_screen.dart:1045`).
 *  - `peerUserBlocked` — the peer has been blocked by an admin
 *    (mirrors `_peerUserBlocked`, `chat_screen.dart:1079`).
 *
 * Priority order when more than one condition is true (mirrors
 * `chat_screen.dart:973-984`): `currentUserBlocked` beats
 * `currentUserBlockedByPeer` beats `peerUserBlocked`. At most one renders.
 */

export enum BlockedOverlayVariant {
  currentUserBlocked = 'currentUserBlocked',
  currentUserBlockedByPeer = 'currentUserBlockedByPeer',
  peerUserBlocked = 'peerUserBlocked',
}
